import React from "react";
import styled from "styled-components";

import { colours } from "../../../utils";
import { Device } from "../../../utils/device";
import { CXXL } from "@/components/Typography";

type StyleProps = {
  index?: number;
};

const StatsContent = () => {
  const stats = [
    {
      copy: (
        <>
          <S.BoldWrap>Debut</S.BoldWrap>
          <br />
          <S.RoxboroughFontWrap>
            <S.ItalicWrap>year</S.ItalicWrap>
          </S.RoxboroughFontWrap>
        </>
      ),
      image: {
        alt: "",
        src: "/images/accelerate/accelerate-woman-writing.png",
      },
      number: "2021",
    },
    {
      copy: (
        <>
          <S.BoldWrap>Global</S.BoldWrap>
          <br />
          <S.RoxboroughFontWrap>
            <S.ItalicWrap>speakers</S.ItalicWrap>
          </S.RoxboroughFontWrap>
        </>
      ),
      image: {
        alt: "",
        src: "/images/accelerate/accelerate-woman-outside.png",
      },
      number: "150+",
    },
    {
      copy: (
        <>
          <S.BoldWrap>Event</S.BoldWrap>
          <br />
          <S.RoxboroughFontWrap>
            <S.ItalicWrap>attendees</S.ItalicWrap>
          </S.RoxboroughFontWrap>
        </>
      ),
      image: {
        alt: "",
        src: "/images/accelerate/accelerate-woman-in-green.png",
      },
      number: "5000+",
    },
    {
      copy: (
        <>
          <S.BoldWrap>Total reach</S.BoldWrap>
          <br />
          <S.RoxboroughFontWrap>since 2021</S.RoxboroughFontWrap>
        </>
      ),
      image: {
        alt: "",
        src: "/images/accelerate/accelerate-woman-in-green.png",
      },
      number: "121M+",
    },
  ];

  return (
    <S.Section>
      <S.StatsContainer>
        {stats.map((item, index) => (
          <S.StatBlock index={index} key={item.number}>
            <S.StatNumber
              colour={colours.accelerateOrange}
              weight="800"
              color="#222A59"
            >
              {item.number}
            </S.StatNumber>
            <S.StatCopy weight={700} lineHeight={1} textAlign="center">
              {item.copy}
            </S.StatCopy>
          </S.StatBlock>
        ))}
      </S.StatsContainer>
    </S.Section>
  );
};

const S = () => {};

S.Section = styled.section`
  width: 100%;
  background-image: url(/images/step-forward-2025/light-blue-marble-background.png);
  background-repeat: no-repeat;
  background-size: cover;
  padding: 10%;
  display: flex;
  flex-direction: column;
  gap: 4rem;

  @media (min-width: ${Device.tablet}) {
    padding: 5% 10%;
  }
`;

S.StatsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3rem;

  @media (min-width: ${Device.mobile}) {
    align-items: normal;
    display: grid;
    grid-gap: 5%;
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: ${Device.tablet}) {
    display: grid;
    grid-gap: 5%;
    grid-template-columns: repeat(4, 1fr);
  }
`;

S.StatBlock = styled.article<StyleProps>`
  display: flex;
  flex-direction: column;

  @media (min-width: ${Device.mobile}) {
    align-items: center;
  }
`;

S.StatNumber = styled(CXXL)`
  letter-spacing: -0.3rem;
  font-size: 6rem;

  @media (min-width: ${Device.tablet}) {
    letter-spacing: -0.3rem;
    font-size: 4rem;
  }

  @media (min-width: ${Device.desktop}) {
    letter-spacing: -0.5rem;
    font-size: 7rem;
  }
`;

S.StatCopy = styled(CXXL)`
  font-size: 3rem;
  line-height: 2.5rem;

  @media (min-width: ${Device.tablet}) {
    font-size: 2rem;
  }

  @media (min-width: ${Device.desktop}) {
    font-size: 3.5rem;
  }
`;

S.BoldWrap = styled.span`
  font-weight: 700;
`;

S.ItalicWrap = styled.span`
  font-style: italic;
`;

S.RoxboroughFontWrap = styled.span`
  font-family:
    Roxborough CF,
    sans-serif;
  font-weight: 100;
`;

export default StatsContent;
